<template>
  <section id="header">
    <div class="logo_container">
      <a href="/challenge-maritima">
        <img class="logo" src="../assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        <img class="logo logo_total" src="../assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
      </a>
    </div>
    <div class="nav">
      <ul>
        <li><a href="https://www.maritima.info/pages/challenge-maritima/region/5527/le-challenge-maritima-2022.html" target="_blank">Page du challenge</a></li>
        <li><a href="https://sportips.fr/MAR23/" target="_blank">S'inscrire</a></li>
        <li><a href="https://sportips.fr/challenge-maritima-2022/" target="_blank">Résultats 2022</a></li>
        <li class="fb-link-item">
          <a class="fb-link" href="https://www.facebook.com/groups/1264222330344880/" target="_blank"> <b-icon icon="facebook" aria-hidden="true" font-scale="2" /></a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
